<template>
  <div>
    <b-row>
      <b-col lg="12">
        <div class="card">
          <div class="card-header">
            Detalhes
            <span class="span-is-link span-color-link ml-3">
              <!-- Editar -->
              <i v-if="canEditCustomer" class="fa fa-pencil-square-o" @click="editItem()"></i>
              <!-- Deletar -->
              <i v-if="canDeleteCustomer" class="fa fa-trash trash-color ml-3" @click="deleteItem()"></i>
            </span>
          </div>
          <div class="card-body">
            <div class="row">
              <b-col lg=4>
                <!-- Card detalhes -->
                <b-card :title="customer.social_name" no-body>
                  <b-card-body>
                    <b-card-title v-if="customer.social_name">{{ customer.social_name }}</b-card-title>
                    <b-card-title v-else>{{ customer.name }}</b-card-title>
                    <p v-if="!customer.is_pf">{{ customer.name }}</p>
                    <b-link href="" class="card-link"><i class="fa fa-envelope-o"></i> {{ customer.email }}</b-link>
                  </b-card-body>
                  <b-list-group flush>
                    <div v-if="$store.getters['auth/isAdmin']">
                      <b-list-group-item v-if="customer.rg || customer.cpf || customer.cnh">
                        <span v-if="customer.rg">RG: {{ customer.rg | VMask('##.###.###-#') }}</span> <br>
                        <span v-if="customer.cpf">CPF: {{ customer.cpf | VMask('###.###.###-##') }}</span> <br>
                        <span v-if="customer.cnh">CNH: {{ customer.cnh }}</span> <br>
                      </b-list-group-item>
                      <b-list-group-item v-if="customer.cnpj">
                        CNPJ: {{ customer.cnpj | VMask('##.###.###/####-##') }}
                      </b-list-group-item>
                      <b-list-group-item v-if="customer.ie || customer.imun">
                        <span v-if="customer.ie">Inscrição Estadual: {{ customer.ie }}</span> <br>
                        <span v-if="customer.imun">Inscrição Municipal: {{ customer.imun }}</span>
                      </b-list-group-item>
                    </div>
                    <b-list-group-item>
                      <b-card-text>
                        {{ customer.full_address }}<br>
                        {{ customer.address_complement }}<br>
                        CEP: {{ customer.cep }}
                      </b-card-text>
                    </b-list-group-item>
                    <b-list-group-item v-if="customer.info">
                      <b-card-text>
                        <b>Informações</b><br>
                        {{ customer.info }}
                      </b-card-text>
                    </b-list-group-item>
                    <b-list-group-item v-if="customer.observation">
                      <b-card-text>
                        <b>Observações</b><br>
                        {{ customer.observation }}
                      </b-card-text>
                    </b-list-group-item>
                  </b-list-group>
                </b-card>
              </b-col>
              <b-col lg=4>
                <!-- Card Contatos -->
                <b-card no-body>
                  <template v-slot:header>
                    <h4 class="mb-0 d-inline">Contatos</h4>
                    <span class="span-is-link badge badge-success float-right" @click="openContactModal()">
                      <i class="fa fa-plus"></i> Adicionar
                    </span>
                  </template>
                  <b-list-group flush>
                    <b-list-group-item>
                      <table class="table table-responsive-sm table-outline">
                        <tbody>
                          <tr v-for="item in customer.customer_contacts" :key="item.pk">
                            <td>
                              <span class="lead">{{ item.name }}</span> <span v-if="item.financial_contact"> - Financeiro</span><br>
                              <b-link v-if="item.email" href="" class="card-link"><i class="fa fa-envelope-o"></i> {{ item.email }} <br></b-link>
                              <i class="fa fa-phone"></i> {{ item.phone }} <br>
                              <i v-if="item.phone2" class="fa fa-phone"></i> {{ item.phone2 }}
                            </td>
                            <td class="p-1">
                              <span v-if="canEditCustomer" @click="openContactModal(item)">
                                <i class="fa fa-pencil-square-o span-is-link span-color-link"></i>
                              </span>
                            </td>
                            <td class="p-1">
                              <span v-if="canDeleteCustomer" @click="deleteContact(item)">
                                <i class="fa fa-trash trash-color"></i>
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </b-list-group-item>
                  </b-list-group>
                </b-card>
              </b-col>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <!-- Modal Customer -->
    <ValidationObserver ref="observer" v-slot="{ passes }">
      <b-modal :visible="isVisible" title="Editar Cliente" @ok.prevent="passes(sendItem)" @hidden="clearModal" cancel-title="Cancelar" ok-title="Salvar">
        <generic-form :fields="fields" :editing="editingItem"></generic-form>
      </b-modal>
    </ValidationObserver>
    <!-- Modal Contact -->
    <b-modal :visible="isContactVisible" :title="editingContact.pk ? 'Editar Contato' : 'Adicionar Contato'" cancel-title="Cancelar" ok-title="Salvar" @ok="saveContact" @hidden="clearModal">
      <b-form-group label="Nome" label-for="editingContactName">
        <b-form-input id="editingContactName" v-model="editingContact.name"></b-form-input>
      </b-form-group>
      <b-form-group label="E-mail" label-for="editingContactEmail">
        <b-form-input id="editingContactEmail" type="email" v-model="editingContact.email"></b-form-input>
      </b-form-group>
      <b-form-group label="Telefone 1" label-for="editingContactPhone">
        <b-form-input id="editingContactPhone" v-model="editingContact.phone"></b-form-input>
      </b-form-group>
      <b-form-group label="Telefone 2" label-for="editingContactPhone2">
        <b-form-input id="editingContactPhone2" v-model="editingContact.phone2"></b-form-input>
      </b-form-group>
      <b-form-group label="Contato Financeiro" label-for="editingContactFinancialContact">
        <b-form-checkbox 
          id="editingContactFinancialContact" 
          v-model="editingContact.financial_contact"
          switch
        >
          É o contato responsável pelo financeiro?
        </b-form-checkbox>
      </b-form-group>
    </b-modal>
  </div>
</template>
<script>
import axios from 'axios';
import Vue from 'vue';

import states from '../../utils/states';
import GenericForm from '../../components/GenericForm';

export default {
  components: {
    GenericForm
  },
  data() {
    return {
      customer: {},
      editingItem: {
        social_name: '',
        name: '',
        email: '',
        cep: '',
        address: '',
        address_number: '',
        complement: '',
        district: '',
        city: '',
        uf: '',
        cpf: '',
        rg: '',
        cnh: '',
        cnpj: '',
        ie: '',
        imun: '',
        observation: '',
      },
      editingContact: {
        name: '',
        email: '',
        phone: '',
        phone2: '',
        financial_contact: false
      },
      isPF: false,
      isVisible: false,
      isContactVisible: false,
    }
  },
  created() {
    const pk = this.$route.params.pk;
    const customer = this.$store.state.customers.items.find(e => e.pk == pk);

    if (customer) {
      this.customer = customer;
      this.loadContacts();

      this.isPF = customer.is_pf;

      // breadcrumb
      this.$store.dispatch('setBreadcrumbs', [{
        name: 'Home',
      }, {
        name: 'Clientes',
      }, {
        name: customer.social_name ? customer.social_name : customer.name,
      }]);

        return;
      }

    axios.get('/crm/customers/' + pk + '/')
      .then(response => {
        this.customer = response.data.data;
        this.loadContacts();

        this.isPF = this.customer.is_pf;

        // breadcrumb
        this.$store.dispatch('setBreadcrumbs', [{
          name: 'Home',
        }, {
          name: 'Clientes',
        }, {
          name: this.customer.social_name ? this.customer.social_name : this.customer.name
        }]);

      });
  },
  destroyed() {
    this.$store.dispatch('setBreadcrumbs', []);
  },
  computed: {
    canEditCustomer() {
      return this.$store.state.auth.user.permission_codes.includes('change_customer');
    },
    canDeleteCustomer() {
      return this.$store.state.auth.user.permission_codes.includes('delete_customer');
    },
    fields() {
      const fields = [{
        text: 'Ativo',
        name: 'active',
        type: 'checkbox'
      }, {
        text: this.isPF ? 'Nome Social' : 'Razão social',
        name: 'social_name',
        limit: 100,
        rules: 'required',
      }, {
        text: this.isPF ? 'Nome' : 'Nome fantasia',
        name: 'name',
        limit: 100,
        // rules: 'required',
      }, {
        text: 'E-mail',
        name: 'email',
        type: 'email',
      }, {
        text: 'CEP',
        name: 'cep',
        type: 'cep',
      }, {
        text: 'Endereço',
        name: 'address',
      }, {
        text: 'Número',
        name: 'address_number',
        type: 'number',
      }, {
        text: 'Complemento',
        name: 'complement',
      }, {
        text: 'Bairro',
        name: 'district',
      }, {
        text: 'Cidade',
        name: 'city',
      }, {
        text: 'UF',
        name: 'uf',
        options: states
      }, {
          text: 'Observações',
          name: 'observation',
          type: 'textarea'
      }];

      if (this.isPF) {
        fields.push(...[{
          text: 'CPF',
          name: 'cpf',
          rules: 'required',
          type: 'mask',
          mask: '###.###.###-##',
        }, {
          text: 'RG',
          name: 'rg',
          rules: 'required',
          type: 'mask',
          mask: '##.###.###-#',
        }, {
          text: 'CNH',
          name: 'cnh',
        }]);
      } else {
        fields.push(...[{
          text: 'CNPJ',
          name: 'cnpj',
          type: 'mask',
          mask: '##.###.###/####-##',
        }, {
          text: 'Inscrição Estadual',
          name: 'ie',
        }, {
          text: 'Inscrição Municipal',
          name: 'imun',
        }]);
      }

      return fields;
    }
  },
  methods: {
    loadContacts() {
      axios.get('/crm/customers/contact/' + this.customer.pk + '/')
        .then(response => {
          Vue.set(this.customer, 'customer_contacts', response.data.data);
        });
    },
    editItem() {
      this.isVisible = true;

      this.editingItem = { ...this.customer };
    },
    openContactModal(item) {
      if (item) {
        this.editingContact = { ...item };
      }

      this.isContactVisible = true;
    },
    async sendItem() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return
      }
      this.$store.dispatch('customers/editItem', this.editingItem)
      this.customer = {
        ...this.editingItem,
        full_address: this.editingItem.address + ', ' + this.editingItem.address_number + ' ' + this.editingItem.complement,
        address_complement: this.editingItem.district + ' - ' + this.editingItem.city + ' - ' + this.editingItem.uf,
      }
      this.clearModal()
    },
    saveContact() {
      const pk = this.$route.params.pk;
      let bodyFormData = new FormData();

      Object.keys(this.editingContact).forEach(i => bodyFormData.append(i, this.editingContact[i]))
      if (this.editingContact.pk) {
        axios.post('/crm/customers/contact/' + this.editingContact.pk + '/edit/', bodyFormData)
          .then(response => {
            const index = this.customer.customer_contacts.findIndex(c => c.pk == this.editingContact.pk);
            Vue.set(this.customer.customer_contacts, index, response.data.data);
          });
      } else {
        axios.post('/crm/customers/contact/' + pk + '/add/', bodyFormData)
          .then(response => {
            this.customer.customer_contacts.push(response.data.data);
          });
      }
    },
    deleteItem() {
      const pk = this.$route.params.pk;
      this.$swal.fire({
        title: 'Deletar item',
        text: 'Deseja realmente apagar esse item?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          axios.post('/crm/customers/' + pk + '/delete/')
            .then(response => {
              window.location.href = '/app/crm/customers/'
            });
        }
      });
    },
    deleteContact(item) {
      this.editingContact = item;
      this.$swal.fire({
        title: 'Deletar item',
        text: 'Deseja realmente apagar esse item?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          axios.post('/crm/customers/contact/' + this.editingContact.pk + '/delete/')
            .then(response => {
              const index = this.customer.customer_contacts.findIndex(c => c.pk == this.editingContact.pk);
              this.customer.customer_contacts.splice(index, 1)
              this.clearModal();
            });
        }
      });
    },
    clearModal() {
      this.editingItem = {
        social_name: '',
        name: '',
        email: '',
        cep: '',
        address: '',
        address_number: '',
        complement: '',
        district: '',
        city: '',
        uf: '',
        cpf: '',
        rg: '',
        cnh: '',
        cnpj: '',
        ie: '',
        imun: '',
      },
      this.isVisible = false;
      this.editingContact = {
        name: '',
        email: '',
        phone1: '',
        phone2: '',
        financial_contact: false,
      };
      this.isContactVisible = false;
    }
  }
}

</script>
